import React from 'react';
import Nailserice from '../assets/nailser.jpeg';
import eyelash from '../assets/eyelash.jpg';
import lami from '../assets/lami.jpg';
import lamibrows from '../assets/lami brows.jpg'
import './Service.css';
const Lash = () => {
  return (
    <>
<div className="homepageimg">
        <img src={Nailserice} alt="Beauty Destination" className="full-screen-image bgimg" />
   </div>
<div className="d-flex justify-content-center pt-5">
  <h1 style={{ color: '#b37777', fontStyle: 'italic', fontFamily: "'TAN TWINKLE', cursive" }}>Lash Services</h1>
</div>
   <div className="container pt-2 ">
    <div className="row align-items-center animate-form1 servicecontainer">
        <div className="col-sm-6">
            <h1 className="service-header text-center">Eyelash Extensions</h1>
            <p>
              Eyelash Extensions
              Lift your eyes with stunning,
               effortless beauty. Our premium Eyelash Extensions add length, volume, and definition, 
               creating a full, captivating look that lasts. Wake up with flawless, long lashes every day!                   </p>
            <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
        </div>
        <div className="col-sm-6">
            <img src={eyelash} alt="Nail Services" style={{width: "100%", height: "500px"}}  />
        </div>
       
    </div>
    <div className="row align-items-center animate-form servicecontainer">
      
      <div className="col-sm-6">
          <img src={lami} alt="Nail Services" style={{width: "100%", height: "500px"}}  />
      </div>
      <div className="col-sm-6">
        <h1 className="service-header text-center pt-2">Lami Lashes</h1>
        <p>
          Elevate your natural beauty with Lami Lashes—voluminous, fluttery lashes that create a stunning, 
          eye-catching look. Perfect for adding length,thickness, and charm to your eyes. Feel confident and
           gorgeous with every blink!       
           </p>
        <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
  </div>
  <div className="row align-items-center animate-form1 servicecontainer">
    <div className="col-sm-6">
        <h1 className="service-header text-center">Lami Brows & Lashes</h1>
        <p>
          Enhance your natural beauty with flawless brows and stunning lashes. Our Lami Brows & Lashes service creates bold, defined brows and 
          beautifully curled lashes for a captivating, effortless look. Stay flawless and gorgeous all day long!         
        </p>     
           <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
    <div className="col-sm-6">
        <img src={lamibrows} alt="Nail Services" style={{width: "100%", height: "500px"}}  />
    </div>
   
</div>
</div>

    
    </>
  )
}
export default Lash;